<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-motivocreate">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center"><b>Crear Motivo de descuento</b></h5>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div>
                                <span>Tipo de Descuento</span>
                                <select v-model="descuentotipo" class="form-control">
                                    <option v-for="(d, ind) in descuentos_tipo" :key="ind" :value="d"> {{ d.id }} - {{ d.nombre }} </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div>
                                <span>Unidad de negocio</span>
                                <select v-model="unidad" class="form-control">
                                    <option v-for="(d, ind) in unidades" :key="ind" :value="d"> ({{d.id}}) {{ d.nombre }} </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div>
                                <span>Descripcion</span>
                                <input type="text" class="form-control" v-model.trim="descripcion" />
                            </div>
                        </div>
                    </div>

                    <p class="text-center text-danger">
                        <b>{{ msg }}</b>
                    </p>
                    <div class="text-center">
                        <div style="display: inline-block;" v-show="loading" class="loader"></div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button @click="validar()" :disabled="loading" type="button" class="btn btn-azul">Registrar</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            area: { nombre: null },
            descuentotipo: {},
            descuentos_tipo: [],
            unidades: [
                { id: 1, nombre: "ESAM" },
                { id: 2, nombre: "CCA" }, 
                { id: 3, nombre: "CiberKids" },
                { id: 4, nombre: "CAS" },
                { id: 10, nombre: "DBS" },
                { id: 12, nombre: "CCTP" },
            ],
            unidad: {},
            descripcion: "",
            loading: false,
            msg: "",
            estado: "",
            respuesta: "",
            proceder_text: "",
        };
    },
    watch: {},
    components: {},
    methods: {
        open() {
            this.unidad = {};
            this.descuentotipo = {};
            this.descripcion = '';
            this.msg = '';
            window.$("#modal-motivocreate").modal("show");
            this.getdecuentostipos();
        },
        getdecuentostipos() {
            const vue = this;
            const urld = `${process.env.VUE_APP_API_REST}/api/v1/descuento-tipos`;
            this.descuentos_tipo = [];
            vue.loading = true;
            axios.get(urld)
            .then((res) => {
                window.console.log(res);
                res.data.data = res.data.data.filter( x => { return x.id != 1 } ) // el id 1 no tomar en cuenta
                // res.data.data = res.data.data.filter( x => { return x.id != -1 } ) // el id 1 no tomar en cuenta
                vue.descuentos_tipo = res.data.data;
                vue.loading = false;
            }).catch((error) => {
                window.console.error(error);
                vue.loading = false;
            });
        },
        validar(){
            this.msg = '';
            const vue = this;
            if( !this.descripcion ) { this.msg = 'Ingrese la descripcion'; return; }
            if( !this.descuentotipo.id ) { this.msg = 'Seleccione el tipo de descuento'; return; }
            if( !this.unidad.id ) { this.msg = 'Seleccione la unidad de negocio'; return; }
            this.loading = true;
            let data = {
                "descripcion": this.descripcion,
                "descuento_tipo_id": this.descuentotipo.id,
                "unidad_negocio_id": this.unidad.id
            }
            const url = `${process.env.VUE_APP_API_REST}/api/v1/motivos`;
            axios.post(url,data)
            .then((res) => {
                window.console.log(res);
                vue.msg = res.data.data;
                vue.loading = false;
            }).catch((error) => {
                window.console.error(error);
                vue.msg = error;
                vue.loading = false;
            });

        },
    },
    mounted() {},
};
</script>
